import React, { useState, useEffect } from "react";
import { Calendar, MapPin, Users, Search } from "lucide-react";
import "../Styles/EventsPage.css";
import NavBar from "../NavBar";
import API_BASE_URL from "../../config";

const subPillars = [
  "E-Sports",
  "Professional Development",
  "Graphic Design",
  "Entrepreneurship & Industrial Relations",
];

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activePillar, setActivePillar] = useState("All");

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/events`);
      const data = await res.json();
      if (Array.isArray(data.events)) setEvents(data.events);
      else if (Array.isArray(data.data)) setEvents(data.data);
      else if (Array.isArray(data)) setEvents(data);
      else setEvents([]);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const filteredEvents = events.filter((event) => {
    const matchesSearch = event.title
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesPillar =
      activePillar === "All" || event.subPillar === activePillar;
    return matchesSearch && matchesPillar;
  });

  console.log("Event data:", events);

  return (
    <div className="events-page">
      <NavBar />
      <br />

      <h1 className="page-title">Discover Events</h1>

      {/* Search bar */}
      <div className="search-container">
      
        <input
          type="text"
          placeholder="Search for events..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-bar"
        />
      </div>

      {/* Sub-Pillar Filters */}
      <div className="pill-container">
        {["All", ...subPillars].map((pillar) => (
          <button
            key={pillar}
            className={`pill ${activePillar === pillar ? "active" : ""}`}
            onClick={() => setActivePillar(pillar)}
          >
            {pillar}
          </button>
        ))}
      </div>

      {/* Event Cards */}
      <div className="events-scroll">
        {filteredEvents.length > 0 ? (
          filteredEvents.map((event) => (
            <div key={event._id} className="event-card">
              {/* Event Banner */}
              <img
                src={
                  event.banner
                    ? `${API_BASE_URL}/${event.banner.replace(/\\/g, "/")}`
                    : "/default-event.jpeg"
                }
                alt={event.title}
                className="event-banner"
              />

              <div className="event-content">
                <div>
                  {event.featured && <span className="ribbon">FEATURED</span>}
                  <h3 className="event-title">{event.title}</h3>
                  <p className="event-desc">{event.description}</p>

                  <div className="event-details">
                    <div>
                      <Calendar size={16} />{" "}
                      {new Date(event.date).toLocaleDateString()} at {event.time}
                    </div>
                    {event.location && (
                      <div>
                        <MapPin size={16} /> {event.location}
                      </div>
                    )}
                    {event.capacity && (
                      <div>
                        <Users size={16} /> {event.capacity} seats
                      </div>
                    )}
                  </div>

                  <span className="badge">{event.subPillar}</span>
                </div>

                {event.registrationLink && (
                  <a
                    href={event.registrationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="register-btn"
                  >
                    Register
                  </a>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="no-events">No events found.</p>
        )}
      </div>
      <br /><br /><br />

    </div>
  );
};

export default EventsPage;
